/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGetDeveloperInfoRequest, TGetDeveloperInfoModel, IMappers, TGetDeveloperInfoResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetDeveloperInfoResponse } from '../../entities/get_developer_info/GetDeveloperInfoResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetDeveloperInfoModel(parameters: IGetDeveloperInfoRequest): TGetDeveloperInfoModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'developer-card',
    pathApi: '/v1/get-developer-info/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetDeveloperInfoOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetDeveloperInfoRequest;
}

export async function fetchGetDeveloperInfo<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetDeveloperInfoOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetDeveloperInfoResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetDeveloperInfoModel(parameters),
    config,
  )) as FetchResponse<TGetDeveloperInfoResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetDeveloperInfoResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetDeveloperInfoResponse>;
}
